"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("../../molecules/card/Card");
const tags_1 = require("../../atoms/tags");
const table_1 = require("../../molecules/table");
const form_1 = require("../../atoms/form");
const hooks_1 = require("../../shared/hooks");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const Wrapper = styled_components_1.default.div `
  td {
    vertical-align: middle;
    align-items: center;
    justify-items: center;
    padding: ${({ theme }) => theme.spacings.xxs} 0;

    &:first-child {
      place-self: start;
    }
  }

  th {
    font-weight: normal;
    place-self: start;
  }

  table {
    column-gap: 0.9rem;
    @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
      justify-items: end;
    }
  }

  input {
    font-size: 0.75rem;
    position: relative;
    top: -0.1rem;
    height: 1.5rem;
    width: 3rem;
    text-align: center;
    padding: ${({ theme }) => `${theme.spacings.xs} 0`};

    &[disabled] {
      background-color: ${({ theme }) => theme.colors.silverLighten70};
      border-color: ${({ theme }) => theme.colors.silverLighten40};
      color: ${({ theme }) => theme.colors.greyLighten40};
    }
  }
`;
const Card = ({ title, subscription, capacities, capacityTypes, inputValueResolver, calculateAvailableCapacity, onCapacitiesChange, tableIndex }) => {
    const [t] = (0, react_i18next_1.useTranslation)();
    const { isOffline } = (0, hooks_1.useNetwork)();
    const { isMobile, isPhoneMini } = (0, hooks_1.useRWD)();
    const CardHeader = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { style: { display: "inline" }, children: title }, void 0), (0, jsx_runtime_1.jsx)(tags_1.Tag, { subscription: subscription, children: subscription }, void 0)] }, void 0));
    const inputRowWidth = isMobile ? 3 : 6.75;
    const labels = [
        t(`capacity${!isMobile ? "" : ".mobile"}.capacityTypes.maximum`),
        t(`capacity${!isMobile ? "" : ".mobile"}.capacityTypes.reserved`),
        t(`capacity${!isMobile ? "" : ".mobile"}.capacityTypes.taken`),
        t(`capacity${!isMobile ? "" : ".mobile"}.capacityTypes.available`)
    ];
    return ((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(Card_1.Card, { header: CardHeader, children: (0, jsx_runtime_1.jsxs)(table_1.Table, { columns: `${isPhoneMini ? "" : "auto"} repeat(3, ${inputRowWidth}rem) minmax(50px, max-content)`, children: [(0, jsx_runtime_1.jsxs)(table_1.TableRow, { children: [!isPhoneMini && (0, jsx_runtime_1.jsx)(table_1.TableHeader, {}, void 0), labels.map((label) => ((0, jsx_runtime_1.jsx)(table_1.TableHeader, { children: label }, label)))] }, void 0), capacities.map((capacity, i) => (!isMobile || i < 1) && ((0, jsx_runtime_1.jsxs)(table_1.TableRow, { children: [!isPhoneMini && ((0, jsx_runtime_1.jsxs)(table_1.TableCell, { children: [!isMobile && t("capacity.fromDate"), " ", capacity.date] }, void 0)), capacityTypes.map((capacityType, j) => ((0, jsx_runtime_1.jsx)(table_1.TableCell, { children: (0, jsx_runtime_1.jsx)(form_1.Input, { disabled: capacityType !== capacityTypes[0] ||
                                        j > 0 ||
                                        i > 0 ||
                                        isOffline, onChange: (e) => {
                                        onCapacitiesChange &&
                                            onCapacitiesChange(tableIndex, e.target.value);
                                    }, value: inputValueResolver &&
                                        inputValueResolver(capacityType, capacity, subscription, calculateAvailableCapacity) }, void 0) }, `${i}${j}`)))] }, i)))] }, void 0) }, void 0) }, void 0));
};
exports.Card = Card;
//# sourceMappingURL=card.js.map